import {useTranslation} from '@/translations/i18n'
import {Button} from '@components/ui/button'
import {AirbnbIcon} from '@components/ui/icon'
import {FC, useState} from 'react'
import {Spinner} from '@components/ui/spinner'
import {envVars} from '@/envVars'
import {cn} from '@utilities/helpers'

interface AirbnbSSOWidgetProps {
    title: string
    description: string
    image: string
    redirectUrl: string
    className?: string
}
export const AirbnbSSOWidget: FC<AirbnbSSOWidgetProps> = ({title, description, image, redirectUrl, className}) => {
    const {t} = useTranslation()
    const [isLoading, setIsLoading] = useState(false)

    const airbnbLoginHandler = () => {
        setIsLoading(true)

        if (redirectUrl) {
            localStorage.setItem('navigate-login-redirect-url', redirectUrl)
        }

        window.location.href = `https://www.airbnb.com/oauth2/auth?client_id=${envVars.VITE_AIRBNB_APP_ID}&redirect_uri=${envVars.VITE_AIRBNB_DATA_REDIRECT_URI}&scope=${envVars.VITE_AIRBNB_DATA_SCOPE}`
    }
    return (
        <div
            className={cn(
                'h-full w-full max-w-120 text-center grid grid-rows-[1fr_auto] gap-8 items-center',
                className
            )}
        >
            <div className="flex flex-col gap-8 items-center w-full">
                <img src={image} alt="Airbnb SSO Widget Image" className="w-39 h-39 aspect-square" />

                <div className="flex flex-col gap-3 items-center">
                    <h3 className="text-display-sm font-medium">{title}</h3>
                    <p className="text-lg text-neutral-700">{description}</p>
                </div>
            </div>

            <Button variant="primary" className="w-full" onClick={airbnbLoginHandler} disabled={isLoading}>
                {isLoading ? (
                    <Spinner size={18} />
                ) : (
                    <>
                        <AirbnbIcon />
                        {t('commons:sign_in')}
                    </>
                )}
            </Button>
        </div>
    )
}
AirbnbSSOWidget.displayName = 'AirbnbSSOWidget'
